import SlideApi from '@/api/slide'

const getSlidesAction = async ({ commit, state }) => {
  const { presentation } = state

  const slides = await SlideApi.getSlides(presentation.id)

  commit('setSlides', slides)

  return slides
}

export default {
  getSlidesAction,
}
